import React from 'react';
import styles from './buttons.module.scss';

const SecondaryButton = (props) => {

  const { text, onClick, style } = props;

  return (
      <button
        type="button"
        className={styles.secondaryBtn}
        onClick={onClick}
        style={style}>
          {text}
        </button>
    );
}

export default SecondaryButton;
